export default __webpack_public_path__ + "static/media/BLYSK_POD_IKONY.88a81b17.gif";